export default __webpack_public_path__ + "static/media/GenieCamellia1.81d61ece.jpg";